import { FreespinComebackResult } from "model/freespin-comeback-result";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class SGFreespinsRetriggered extends Decision {
    public evaluate() {
        const currentRecord = GameState.getCurrentGame().getCurrentRecord();

        const inFreespin = currentRecord instanceof FreespinRecord;
        const freespinsWinResult = currentRecord.getResultsOfType(FreespinWinResult)[0];
        const scatterPresent = freespinsWinResult && freespinsWinResult.linkedResult instanceof ScatterResult;
        const freespinsRetriggered = inFreespin && freespinsWinResult && scatterPresent;

        const comebackAwarded = currentRecord.getResultsOfType(FreespinComebackResult).length;

        return freespinsRetriggered || comebackAwarded ? Exit.True : Exit.False;
    }
}
